// extracted by mini-css-extract-plugin
export default {"menu":"MultiSelectDropdown_menu__VWTJm","dropdown":"MultiSelectDropdown_dropdown__141WI"};